/**
 * A tela de preferências de aviso do PORTAL (D3, passo 19 — PR 2; desenho do portal peça J). É a MESMA `PreferenciasDeAviso` do interno com a
 * API do portal (`/portal/notifications/preferences/avisos`, cache próprio), as 3 categorias do parceiro, o cartão de push do portal,
 * a moldura do portal e a disposição EMPILHADA (rótulo em cima, pílulas embaixo: a página é `max-w-3xl` e o cartão tem 656 px úteis,
 * onde a grade "lado" de 860 px não cabe).
 * Textos do desenho §5.4: não mudam sem passar pelo Augusto.
 */
import { TEXTOS_DO_PUSH_DO_PORTAL } from "@/components/notifications/CartaoPushDoAparelho.textos";
import { CATEGORIAS_DO_PORTAL } from "@/components/notifications/categoriasDeAviso";
import type { VarianteDasPreferencias } from "@/components/notifications/PreferenciasDeAviso.variante";
import { PUSH_BASE_PORTAL } from "@/hooks/usePushSubscription";
import { ADAPTADOR_DO_PORTAL } from "@/services/portalPreferenciasDeAvisoService";

export const TEXTO_DOS_NIVEIS_DO_PORTAL =
  "Aviso + som: aparece na tela e toca. Aviso sem som: só aparece na tela. Só no sino: não aparece na tela, " +
  'fica no sino para ver depois. Não receber: não entra nem no sino. No Atendimento, "Só no contador do ' +
  'Atendimento" é o número no menu Atendimento.';

/** A moldura que o portal usa em TODO cartão (`PortalPreferenciasPage`, `PainelDeNotificacoes`). */
export const CLASSE_DO_CARTAO_DO_PORTAL = "border-emerald-100/80 bg-white/80 backdrop-blur-sm";

export const VARIANTE_DO_PORTAL: VarianteDasPreferencias = {
  adaptador: ADAPTADOR_DO_PORTAL,
  categorias: CATEGORIAS_DO_PORTAL,
  textoDosNiveis: TEXTO_DOS_NIVEIS_DO_PORTAL,
  orientacaoDoErro: "Tente de novo. Se continuar, fale com a equipe pelo Atendimento.",
  push: { basePath: PUSH_BASE_PORTAL, textos: TEXTOS_DO_PUSH_DO_PORTAL },
  classeDaRaiz: "space-y-6",
  classeDoCartao: CLASSE_DO_CARTAO_DO_PORTAL,
  disposicao: "empilhada",
  linhasDoEsqueleto: 3,
  semCabecalho: true,
};
